/**
 * @fileoverview File upload validation utilities.
 * Validates filenames for special characters, length limits, and file size restrictions.
 */

/**
 * Validates file upload against naming and size constraints.
 * Checks for non-ASCII characters, filename length (max 256), and file size (max 25MB).
 *
 * @param {File} file - File object to validate
 * @returns {{validated: boolean, errorMessage?: string}} Validation result
 *
 * @example
 * const result = validateFileUpload(file);
 * if (!result.validated) {
 *   alert(result.errorMessage);
 * }
 */
export const validateFileUpload = (file) => {
  const { name, size, type } = file;

  const nonAsciiCharacters = name.match(/[^\x20-\x7F]/g);
  if (nonAsciiCharacters) {
    return {
      validated: false,
      errorMessage: `Please remove the following characters from the file name (${nonAsciiCharacters.join(
        ", "
      )}).`,
    };
  }

  const filenameTooLong = name.length > 256;
  if (filenameTooLong)
    return {
      validated: false,
      errorMessage: `File name should not exceed 256 characters `,
    };

  const filesizeTooBig = size > 26_214_400; // 25MB
  if (filesizeTooBig) return { validated: false, errorMessage: "File size should not exceed 25MB" };

  return { validated: true };
};
